import * as React from "react";

const Youtube: React.FC = () => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="512.000000pt"
            height="512.000000pt"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path
                    d="M259 5101 c-117 -37 -202 -123 -239 -240 -20 -62 -20 -89 -20 -2301
       0 -2212 0 -2239 20 -2301 37 -119 123 -203 242 -241 57 -17 149 -18 2298 -18
       2212 0 2239 0 2301 20 119 37 203 123 241 242 17 57 18 149 18 2298 0 2149 -1
       2241 -18 2298 -38 119 -122 205 -241 242 -62 20 -88 20 -2305 19 -2124 0
       -2244 -1 -2297 -18z m2856 -1431 c616 -22 747 -46 863 -154 96 -90 136 -209
       163 -491 17 -174 18 -730 1 -910 -26 -272 -51 -375 -111 -455 -83 -110 -165
       -152 -349 -175 -493 -62 -1923 -56 -2304 10 -196 34 -320 150 -361 340 -48
       218 -69 677 -47 1030 25 411 55 528 161 640 91 96 177 123 464 145 352 28
       1056 37 1520 20z"
                />
                <path
                    d="M2240 2560 l0 -480 48 27 c615 352 781 449 781 453 0 4 -166 101
       -781 453 l-48 27 0 -480z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Youtube);
